import EventsSlider from "../slider/EventsSlider";

export default function EventsSection({ t }) {
  return (
    <section id="events" className="pt-20 md:pt-32 bg-brand-off-white">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold mb-10 text-center">
          {t.events.heading}
        </h2>
        <EventsSlider events={t.events.list} />
      </div>
    </section>
  );
}
